import { lazyNamedComponent } from './utils/lazy-named-component';

export const ActivityDetailsView = lazyNamedComponent(
  () => import('./activity/activity-details-mobile'),
  'ActivityDetailsView'
);

export const ActivityListView = lazyNamedComponent(
  () => import('./activity/activity-list-view'),
  'ActivityListView'
);

export const Asset3d = lazyNamedComponent(
  () => import('./asset/asset-3d'),
  'Asset3d'
);

export const AssetDocuments = lazyNamedComponent(
  () => import('./asset/asset-documents'),
  'AssetDocuments'
);

export const AssetProperties = lazyNamedComponent(
  () => import('./asset/asset-properties'),
  'AssetProperties'
);

export const AssetTrends = lazyNamedComponent(
  () => import('./asset/asset-trends'),
  'AssetTrends'
);

export const DataModelingOverridePage = lazyNamedComponent(
  () => import('./data-modeling-override-page/data-modeling-override-page'),
  'DataModelingOverridePage'
);

export const IdmObservationsDesktopFormPage = lazyNamedComponent(
  () =>
    import(
      './idm-observations/desktop-form-page/idm-observations-desktop-form-page'
    ),
  'IdmObservationsDesktopFormPage'
);

export const IdmObservationsDesktopTablePage = lazyNamedComponent(
  () =>
    import(
      './idm-observations/desktop-table-page/idm-observations-desktop-table-page'
    ),
  'IdmObservationsDesktopTablePage'
);

export const IdmObservationsMobileListPage = lazyNamedComponent(
  () =>
    import(
      './idm-observations/mobile-list-page/idm-observations-mobile-list-page'
    ),
  'IdmObservationsMobileListPage'
);

export const IdmObservationMobileOverviewPage = lazyNamedComponent(
  () =>
    import(
      './idm-observations/mobile-overview-page/idm-observation-mobile-overview-page'
    ),
  'IdmObservationMobileOverviewPage'
);

export const LandingPage = lazyNamedComponent(
  () => import('./landing-page/landing-page'),
  'LandingPage'
);

export const NotificationDetailsView = lazyNamedComponent(
  () => import('./notification/notification-detail-view'),
  'NotificationDetailsView'
);

export const PageNotFound = lazyNamedComponent(
  () => import('./page-not-found'),
  'PageNotFound'
);

export const TemplatesMobile = lazyNamedComponent(
  () => import('./template/template-on-mobile/templates-mobile'),
  'TemplatesMobile'
);

export const TemplateCreatedConfirmationPage = lazyNamedComponent(
  () =>
    import(
      '../features/template/template-mobile/template-created-confirmation-page/template-created-confirmation-page'
    ),
  'TemplateCreatedConfirmationPage'
);
